import { create } from "zustand";

/**
 * Cross-route + cross-panel navigation state for Mission Control.
 *
 * `activePanel` is the in-page MC mode (matches the vanilla `XAES.showModal`
 * targets from `_legacy/xaes-nav.js`). Phase 1 (3+4/N) wires:
 *
 *   - `OPENING`    full-screen XAES wordmark + plasma orb (first visit)
 *   - `MC_00`      Mission Control capability ring (default after entry)
 *   - `MC_WS{n}`   per-workshop bubble panel
 *
 * `lastWorkshopId` is reserved for Phase 2 — it'll remember which
 * `/workshop/:id` page the user last visited so the HudHeader can show
 * a quick-resume affordance.
 */

export type ActivePanel =
  | "OPENING"
  | "MC_00"
  | "MC_WS1"
  | "MC_WS2"
  | "MC_WS3"
  | "MC_WS4"
  | "MC_WS5"
  | "MC_WS6"
  | "MC_WS7"
  | "MC_WS8";

type NavigationState = {
  activePanel: ActivePanel;
  lastWorkshopId: string | null;
  setActivePanel: (panel: ActivePanel) => void;
  setLastWorkshopId: (id: string | null) => void;
};

export const useNavigation = create<NavigationState>((set) => ({
  activePanel: "OPENING",
  lastWorkshopId: null,
  setActivePanel: (activePanel) => set({ activePanel }),
  setLastWorkshopId: (id) => set({ lastWorkshopId: id }),
}));
